import { createContext, useContext, type ReactNode } from 'react';
import { useAppearance } from '@traceio-org/auth-ui';
import { useRouteLoaderData } from 'react-router';
import type { HubBootstrap } from './bootstrap';
import type { HubDependencies } from './deps';

const HubContext = createContext<HubDependencies | null>(null);

/** Keeps the stored appearance on the root on every hub page, following the device live while it is System. */
function FollowAppearance({ hubOrigin }: { hubOrigin: string | null }) {
  useAppearance(hubOrigin);
  return null;
}

export function HubProvider({ deps, children }: { deps: HubDependencies; children: ReactNode }) {
  return (
    <HubContext.Provider value={deps}>
      <FollowAppearance hubOrigin={deps.config.hubOrigin} />
      {children}
    </HubContext.Provider>
  );
}

export function useHub(): HubDependencies {
  const deps = useContext(HubContext);
  if (!deps) throw new Error('account-hub: HubProvider is missing');
  return deps;
}

export const ROOT_ROUTE_ID = 'root';

/** Host and registry, loaded once by the root route. */
export function useBootstrap(): HubBootstrap {
  const data = useRouteLoaderData(ROOT_ROUTE_ID) as HubBootstrap | undefined;
  if (!data) throw new Error('account-hub: bootstrap data is missing');
  return data;
}
